export default __webpack_public_path__ + "static/media/typewise.357b9d33.png";